/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetMeResponseData,
  GetMeResponseDataFromJSON,
  GetMeResponseDataFromJSONTyped,
  GetMeResponseDataToJSON
} from './GetMeResponseData'

/**
 *
 * @export
 * @interface UpdateMeResponse
 */
export interface UpdateMeResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateMeResponse
   */
  status?: number
  /**
   *
   * @type {GetMeResponseData}
   * @memberof UpdateMeResponse
   */
  data?: GetMeResponseData
}

export function UpdateMeResponseFromJSON(json: any): UpdateMeResponse {
  return UpdateMeResponseFromJSONTyped(json, false)
}

export function UpdateMeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMeResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetMeResponseDataFromJSON(json['data'])
  }
}

export function UpdateMeResponseToJSON(value?: UpdateMeResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetMeResponseDataToJSON(value.data)
  }
}
